import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ForbiddenHandler,
  GlobalMessageType,
} from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class GenForbiddenHandler extends ForbiddenHandler {
  override handleError(request: HttpRequest<any>) {
    if (
      request.url.endsWith(
        this.occEndpoints.buildUrl('user', {
          urlParams: { userId: 'current' },
        })
      )
    ) {
      this.authService.logout();
    } else if(request.url.includes('cpiPriceBundle')) {
      return;
    }
    this.globalMessageService.add(
      { key: 'httpHandlers.forbidden' },
      GlobalMessageType.MSG_TYPE_ERROR
    );
  }
}